const testAudio =
  "//FsQAP//N4EAExhdmM1OC4xMzQuMTAwAAHIZgfOOP/xbEANf/wA5DKDJjYIhAQhYahAO+gDQJ9PBLkd//rI7KgNRXfOTZiGgB8vifIADEXy2Z5iULc1WSFCp8vTOvfN/y2ySjsemXP/mnPPp0ujvoI5bgimXvmFOx+emLKlroz+v+n9/y1sAAAO//FsQAxf/ADkMwMmUBINgmEA/t7VK1zMwBJA6rsevmX8eexva3/c5vb9E7HieDQO7uKasYGaMccuoq7W6LjJoapyitkF/49ZCK6PxWTWq666+906X0uqGZDM1KJp9K8cADj/8WxADN/8AOQzAwZwCIUGYQD+z4e/tV1tASBQa+Dv9J6/rvq+Fo/J8PXAO2zZ2eEvE5uk0gAV6erOrS/e2OJDoAsG4es2CuJuhi/x++5CS/Zd5pYO2b3//3e//fwrkHFv6GndABz/8WxAC//8AOQzA0hAEIUEwTCAfEqKrcCw6hzW8s67ie/tRGr0i+uBQRXFDru/BnQKR/76ogeKwb3RPMyL41zTfSWpYwAuVjTdXtosaE6AZI1GV42PE0yxpMvy9AADgP/xbEAIv/wA5DODQkAaDMIC/Y9plWCIAAMBTxPbFUQVm71goKauqqqcbd2orrb439WPfhXUC6r4izRRbl/1Btn43CABwP/xbEABv/wA5DOD6Bw=";

export function getCanPlayAAC() {
  return new Promise((resolve: (value: boolean) => void) => {
    const audio = document.createElement("audio");

    const onError = () => {
      resolve(false);
      cleanup();
    };

    const onCanPlayThrough = () => {
      resolve(true);
      cleanup();
    };

    const cleanup = () => {
      audio.removeEventListener("canplaythrough", onCanPlayThrough);
      audio.removeEventListener("error", onError);
      audio.pause();
      audio.src = "";
    };

    audio.addEventListener("canplaythrough", onCanPlayThrough);
    audio.addEventListener("error", onError);
    audio.src = `data:audio/aac;base64,${testAudio}`;
    audio.load();
  });
}
